import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { PackageAffectedObjectsComponent } from './package-affected-objects.component';

@NgModule({
    imports: [SharedModule],
    declarations: [PackageAffectedObjectsComponent],
    entryComponents: [PackageAffectedObjectsComponent],
    exports: [PackageAffectedObjectsComponent]
})
export class PackageAffectedObjectsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/packages/packages-list/package-affected-objects/package-affected-objects.module.ts